import queryString from "query-string";
import {
  privateFetch,
  privateFetchWithToken,
  privateFetchJson,
  privateFetchNoBody,
  publicFetch,
  publicFetchNoJSON,
  publicFetchWithTokenHandler,
  publicFetchNoJSONAndNoText,
  privateFetchNoBodyNoJson,
  privateFetchCustomErrorHandling,
  privateFetchNoAuth,
  privateFetchFormFields,
} from "./fetch";
import { SecureLocalStorage } from "helpers";
import { setTokens } from "./tokenHandlers";

export * from "./tokenHandlers";
export * from "./errorHandlers";
export * from "./fetch";
export * from "./subscribeNewsLetter";
export * from "./analytics";
export * from "./punchCard";
export * from "./mailChimp";
export * from "./invoices";

// api calls
export const userAppPermissions = async (appId) => {
  const url = `${__BASE_API_URL__}/userAppPermissions/${appId}`;
  try {
    const parsedUsers = {};
    const users = await privateFetch(url, {
      method: "GET",
    });
    users.forEach((user) => {
      parsedUsers[user.userId] = user;
    });

    return parsedUsers;
  } catch (e) {
    console.log(e);
  }
};

export const getAppInfo = async (appId) => {
  const url = `${__BASE_API_URL__}/applications/${appId}`;

  try {
    return await privateFetch(url, {
      method: "GET",
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAppById = async (appId, accessToken) => {
  const url = `${__BASE_API_URL__}/applications/${appId}`;

  if (accessToken) {
    // console.log("fetching with access token: " + accessToken);
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getSocialFeed = async () => {
  const url = `${__BASE_API_URL__}/socialFeed`;
  try {
    const result = publicFetch(url, {
      method: "GET",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const fetchUserInfo = async (userInvitationToken) => {
  const url = `${__BASE_API_URL__}/userToken?userInvitationToken=${userInvitationToken}`;
  return await publicFetch(url);
};

/**
 * userId: Integer
 * appId: Integer
 * permissionIds: Array
 */
export const savePermissions = async (userId, appId, permissionIds) => {
  const queryParams = queryString.stringify({
    userId,
    appId,
    permissionIds,
  });
  const url = `${__BASE_API_URL__}/savePermissions?${queryParams}`;
  return await privateFetch(url, {
    method: "POST",
  });
};

export const inviteUser = async (
  email,
  firstName,
  lastName,
  appId,
  permissions
) => {
  const invitedBy = SecureLocalStorage.getItem("userId");
  const queryParams = queryString.stringify({
    email,
    firstName,
    lastName,
    appId,
    permissions,
    invitedBy,
  });
  const url = `${__BASE_API_URL__}/inviteUser?${queryParams}`;

  try {
    return await privateFetch(url, {
      method: "POST",
    });
  } catch (e) {
    console.log(e);
  }
};

export const acceptInvitation = async (userInvitationToken) => {
  const queryParams = queryString.stringify({
    userInvitationToken,
  });
  const url = `${__BASE_API_URL__}/acceptInvitation?${queryParams}`;

  try {
    return await privateFetch(url, {
      method: "POST",
    });
  } catch (e) {
    console.log(e);
  }
};

export const uninviteUser = async (email, appId) => {
  const queryParams = queryString.stringify({
    email,
    appId,
  });
  const url = `${__BASE_API_URL__}/uninviteUser?${queryParams}`;

  try {
    return await privateFetch(url, {
      method: "POST",
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateUserPermissions = async (userId, appId, permissionIds) => {
  const queryParams = queryString.stringify({
    userId,
    appId,
    permissionIds,
  });
  const url = `${__BASE_API_URL__}/deleteUserPermissions?${queryParams}`;

  try {
    return await privateFetch(url, {
      method: "DELETE",
    });
  } catch (e) {
    console.log(e);
  }
};

export const requestToPublish = async (userId) => {
  const url = `${__BASE_API_URL__}/requestToPublish?userId=${userId}`;

  try {
    const result = privateFetchNoBody(url, {
      method: "POST",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const postMockAppData = (appId, storeTemplateId) => {
  // console.log("creating app mock data...");
  // console.log(appId);
  // console.log(storeTemplateId);

  const queryParams = queryString.stringify({
    storeTemplateId,
  });

  const url = `${__BASE_API_URL__}/application/${appId}/mockAppData?${queryParams}`;
  try {
    const result = privateFetch(url, {
      method: "POST",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const appByLanding = async (appName) => {
  const url = `${__BASE_API_URL__}/applicationByLandingPage?landingPagePath=${appName}`;
  try {
    const result = publicFetch(url, {
      method: "GET",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

// export const getAppWebpage = async (appId, userId) => {
//   let url = `${__BASE_API_URL__}/applications/${appId}/webpage?userId=${userId}`;
//   if (!userId) url = `${__BASE_API_URL__}/applications/${appId}/webpage`;

//   try {
//     const result = publicFetchWithTokenHandler(url, {
//       method: "GET",
//     });
//     console.log(result);
//     return result;
//   } catch (e) {
//     console.error(e);
//   }
// };

export const slackSignUp = async (firstName, lastName) => {
  const url =
    "https://hooks.slack.com/services/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";
  const text = `\`\`\`New web user! ${firstName} ${lastName}\`\`\``;

  try {
    const result = fetch(url, {
      method: "POST",
      body: JSON.stringify({
        text,
      }),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getQrCode = async (appUrl, width, logo, color) => {
  const url = "https://qrcode-monkey.p.rapidapi.com/qr/custom";
  const config = {
    bodyColor: color,
    logo: logo,
  };

  let opts = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
      "x-rapidapi-host": "qrcode-monkey.p.rapidapi.com",
      "x-rapidapi-key": "f42f95f49emsh10401994fc6d746p1722fbjsn1c28f9b0f0bc",
      useQueryString: "true",
    }),
    qs: {
      size: width,
      file: "png",
      config: JSON.stringify(config),
      data: appUrl,
    },
  };

  try {
    const result = fetch(url, opts);
    // console.log(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getAppsMetadata = async () => {
  const url = `${__BASE_API_URL__}/applicationsMetadata?pageSize=100`;

  try {
    const result = publicFetch(url, {
      method: "GET",
    });
    // console.log(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const slackMessage = async (name, email, phone, message) => {
  console.log("sending slack message....");
  const url =
    "https://hooks.slack.com/services/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";
  const text = `\`\`\`New Note from User!\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\nMessage: ${message}\`\`\``;

  try {
    const result = fetch(url, {
      method: "POST",
      body: JSON.stringify({
        text,
      }),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const slackLeadMessage = async (name, email, phone) => {
  const url =
    "https://hooks.slack.com/services/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";
  const text = `\`\`\`New Note from User!\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\`\`\``;

  try {
    const result = fetch(url, {
      method: "POST",
      body: JSON.stringify({
        text,
      }),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getRewardsTransactions = async (appId) => {
  const url = `${__BASE_API_URL__}/rewardTransactions?appId=${appId}`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getDealsTransactions = async (appId) => {
  const url = `${__BASE_API_URL__}/dealsTransactions?appId=${appId}`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getUserDeals = async (userId, appId) => {
  const url = `${__BASE_API_URL__}/userDeals?userId=${userId}&appId=${appId}`;

  try {
    const deals = await privateFetch(url, {
      method: "GET",
    });
    return deals;
  } catch (e) {
    console.error(e);
  }
};

export const getStoreTransactions = async (appId, dateSince, items) => {
  // console.log("API CALL GOT ITEMS");
  // console.log(items);
  // console.log("GENERATING ITEMS STRING");
  const itemString = items.join(",");
  // console.log(itemString);
  const url = `${__BASE_API_URL__}/orderHistory?sinceDate=${dateSince}&appId=${appId}&purchaseItemIds=${itemString}`;
  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getOrders = async (appId, dateSince, items) => {
  const itemString = items.join(",");
  const url = `${__BASE_API_URL__}/orders?appId=${appId}&sinceDate=${dateSince}&purchaseItemIds=${itemString}`;
  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getAppCoupons = async (appId) => {
  const url = `${__BASE_API_URL__}/app/${appId}/coupons?includeRetired=true`;
  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

// DELETE a coupon in database
export const deleteCoupon = (couponId) => {
  const url = __BASE_API_URL__ + `/coupon/${couponId}`;
  try {
    const result = privateFetch(url, { method: "DELETE" });
    return result;
  } catch (e) {
    console.error(e);
  }
};

// CREATE a coupon in database
export const createCoupon = (appId, coupon) => {
  const url = __BASE_API_URL__ + `/app/${appId}/coupon`;
  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(coupon),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getAppStoreItems = async (appId) => {
  const url = `${__BASE_API_URL__}/purchaseItems?appId=${appId}&includeRetired=true`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getTemplateStoreItems = async (appId, templateId) => {
  const url = `${__BASE_API_URL__}/purchaseItems?appId=${appId}&templateId=${templateId}`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getUsersWhoDownloadedApp = async (
  appId,
  pageNo,
  pageSize,
  accessToken
) => {
  const url =
    __BASE_API_URL__ +
    `/application/${appId}/users?pageNo=${pageNo}&pageSize=${pageSize}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getStoreItemsForUser = async (appId, templateId, userId) => {
  // console.log("XXXXXXXXXXX=======>>>>> got user id: " + userId);
  const url =
    __BASE_API_URL__ +
    `/currentPurchaseItems?userId=${userId}&appId=${appId}&templateId=${templateId}&includeOffline=true&includeRetired=true`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getAllOrders = async (appId, dateSince, templateId) => {
  const url = `${__BASE_API_URL__}/orders?appId=${appId}&sinceDate=${dateSince}&templateId=${templateId}`;
  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const updateOrder = async (orderId, order) => {
  const url = `${__BASE_API_URL__}/order/${orderId}`;
  // console.log("updating order");
  // console.log(order);

  try {
    const result = privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(order),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const storeShippoAccessToken = async (appId, accessToken) => {
  const url = `${__BASE_API_URL__}/application/${appId}/shippoCode?shippoCode=${accessToken}`;
  console.log("storing shippo access token");
  console.log(accessToken);
  // const body = `shippoCode=${accessToken}`;

  try {
    const result = await privateFetchNoBodyNoJson(url, {
      method: "PUT",
      // body: body,
    });
    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// export const mailChimpSignUp = async (email, firstName, lastName) => {
//   const url = `${__BASE_API_URL__}/mailchimp/lists/members`;
//   const body = `email=${email}&firstName=${firstName}&lastName=${lastName}`;

//   try {
//     const result = await fetch(url, {
//       method: "POST",
//       headers: new Headers({
//         "Content-Type": "application/x-www-form-urlencoded",
//       }),
//       body: body,
//     });
//     // console.log(result);
//     if (result.status != 200) {
//       throw "err";
//     }
//     return result;
//   } catch (e) {
//     console.error(e);
//     return "err";
//   }
// };

// export const getShippoAccessToken = async (code) => {
//   const url = "https://goshippo.com/oauth/access_token";
//   const body = {
//     client_id: "d422b1931ad54576ae69dd8a23ee7de5",
//     client_secret: "0Ya-GHIzdoKGfVRvSLgBLeptrTIHdByS-hk-WcUu86c",
//     code: code,
//     grant_type: "authorization_code",
//   };

//   try {
//     const result = publicFetchNoJSONAndNoText(url, {
//       method: "POST",
//       body: JSON.stringify(body),
//     });
//     return result;
//   } catch (e) {
//     // console.log("call found an error");
//     console.error(e);
//   }
// };

export const getStripeExpressDashboardLink = async (appId) => {
  const url = `${__BASE_API_URL__}/stripeExpressDashboardLink?appId=${appId}`;
  try {
    const result = privateFetchNoBodyNoJson(url, {
      method: "GET",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getPaymentIntent = async (paymentObject) => {
  const url = __BASE_API_URL__ + `/orderPaymentSecret`;
  // console.log("MAKING PaymentIntent CALL with Object:");
  const body = paymentObject;
  // console.log(JSON.stringify(body));

  try {
    const result = privateFetchJson(url, {
      method: "POST",
      body: JSON.stringify(body),
    });
    return result;
  } catch (e) {
    // console.log("call found an error");
    console.error(e);
  }
};

export const getInvoicePaymentIntent = async (appId, invoiceId) => {
  const url =
    __BASE_API_URL__ + `/app/${appId}/invoice/${invoiceId}/paymentSecret`;

  // console.log(JSON.stringify(body));

  try {
    const result = privateFetchFormFields(url, {
      method: "POST",
    });
    return result;
  } catch (e) {
    // console.log("call found an error");
    console.error(e);
  }
};

export const incrementAnalyticsCount = async (appId, userId, event) => {
  const url = __BASE_API_URL__ + `/incrementAnalyticsCount`;
  const body = `appId=${appId}&userId=${userId}&event=${event}`;
  try {
    const result = await fetch(url, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const addAddressForUser = async (userId, addressObject) => {
  const url = __BASE_API_URL__ + `/user/${userId}/address`;
  const body = addressObject;

  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const validateDeliveryAddressOnly = async (appId, addressObject) => {
  const url =
    __BASE_API_URL__ + `/app/${appId}/storeSettings/validateDeliveryAddress`;
  const body = addressObject;

  try {
    const result = privateFetchCustomErrorHandling(url, {
      method: "POST",
      body: JSON.stringify(body),
    }).then((res) => {
      // console.dir(res);
      return res;
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getUserAddresses = async (userId) => {
  const url = __BASE_API_URL__ + `/user/${userId}/addresses`;
  // console.log("Getting addresses");
  try {
    const result = privateFetch(url, {
      method: "GET",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getAdvancedStoreTemplate = async (appId, templateId) => {
  const url = `${__BASE_API_URL__}/app/${appId}/storeTemplate/${templateId}`;
  try {
    const result = privateFetch(url, {
      method: "GET",
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const putOrder = (orderId, order) => {
  // console.log("UPDATE STARTED WITH ORDER: ");
  // console.log(order);
  const url = __BASE_API_URL__ + `/order/${orderId}`;
  return new Promise((resolve, reject) => {
    return privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(order),
    })
      .then((newOrder) => {
        // console.log("SUCCESS ON UPDATE!");
        // console.log(newOrder);
        resolve(newOrder);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateAdvancedStoreTemplate = async (advancedStoreTemplate) => {
  const url = `${__BASE_API_URL__}/app/${advancedStoreTemplate.appId}/storeTemplate/${advancedStoreTemplate.templateId}`;

  try {
    const result = await privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(advancedStoreTemplate),
    });
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const getPunchCardTransactions = async (appId) => {
  const url = `${__BASE_API_URL__}/punchcardTransactions?appId=${appId}`;

  try {
    const result = privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const deleteLocations = async (ids) => {
  const url = `${__BASE_API_URL__}/location?ids=${ids}`;

  try {
    const result = privateFetchNoBody(url, {
      method: "DELETE",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const deleteGroup = async (groupId, accessToken) => {
  // console.log("starting api call with id: " + groupId);
  const url = __BASE_API_URL__ + `/additionalOptionsGroup/${groupId}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetchNoBody(url, {
      method: "DELETE",
    });
    // console.dir(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const createGroup = async (storeItemId, group, accessToken) => {
  // console.log("starting create api call with id: " + storeItemId);
  const url =
    __BASE_API_URL__ + `/purchaseItem/${storeItemId}/additionalOptionsGroup`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(group),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }
  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(group),
    });
    // console.dir(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const deleteGroupItem = async (groupItemId, accessToken) => {
  // console.log("starting delete group item api call with id: " + groupItemId);
  const url = __BASE_API_URL__ + `/additionalOptionsItem/${groupItemId}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
      });
      return result;
    } catch (e) {
      console.error(e);
    }
  }
  try {
    const result = privateFetchNoBody(url, {
      method: "DELETE",
    });
    // console.dir(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const createGroupItem = async (groupId, item, accessToken) => {
  const url =
    __BASE_API_URL__ +
    `/additionalOptionsGroup/${groupId}/additionalOptionsItem`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(item),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }

  try {
    const result = privateFetch(url, {
      method: "POST",
      body: JSON.stringify(item),
    });
    // console.dir(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const updateGroup = async (groupId, group, accessToken) => {
  // console.log("starting update api call with id: " + groupId);
  const url = __BASE_API_URL__ + `/additionalOptionsGroup/${groupId}`;

  if (accessToken) {
    try {
      const result = privateFetchWithToken(url, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: accessToken,
        }),
        body: JSON.stringify(group),
      });

      return result;
    } catch (e) {
      console.error(e);
    }
  }
  try {
    const result = privateFetch(url, {
      method: "PUT",
      body: JSON.stringify(group),
    });
    // console.dir(result);
    return result;
  } catch (e) {
    console.error(e);
  }
};

export const deletePhones = async (ids) => {
  const url = `${__BASE_API_URL__}/phoneNumber?ids=${ids}`;

  try {
    const result = privateFetchNoBody(url, {
      method: "DELETE",
    });

    return result;
  } catch (e) {
    console.error(e);
  }
};

export const purchaseSubscription = async (
  sourceToken,
  appId,
  couponId,
  stripePriceId
) => {
  const userId = SecureLocalStorage.getItem("userId");
  let queryParams = "";

  if (couponId) {
    queryParams = queryString.stringify(
      {
        couponId,
        sourceToken,
        appId,
        userId,
        stripePriceId,
      },
      {
        skipNull: true,
      }
    );
  } else {
    queryParams = queryString.stringify(
      {
        sourceToken,
        appId,
        userId,
        stripePriceId,
      },
      {
        skipNull: true,
      }
    );
  }

  const url = `${__BASE_API_URL__}/purchaseSubscription?${queryParams}`;

  try {
    const result = await privateFetch(
      url,
      {
        method: "POST",
      },
      false,
      false
    );

    return result;
  } catch (e) {
    console.error(e);
    // throw e;
  }
};

export const getStripeCustomerCards = async (userId) => {
  const url = `${__BASE_API_URL__}/user/${userId}/stripeCustomer/paymentMethods/raw`;

  try {
    const result = await privateFetch(url, {
      method: "GET",
    });

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const isCouponValid = async (couponCode) => {
  const queryParams = queryString.stringify({
    couponCode,
  });
  const url = `${__BASE_API_URL__}/isCouponValid?${queryParams}`;

  return await privateFetch(
    url,
    {
      method: "GET",
    },
    false,
    false
  );
};

export const getAppNotifications = async (appId) => {
  const queryParams = queryString.stringify({
    appId,
  });
  const url = `${__BASE_API_URL__}/notification?${queryParams}`;

  return await privateFetch(
    url,
    {
      method: "GET",
    },
    false,
    false
  );
};

export const deleteNotification = async (id) => {
  const queryParams = queryString.stringify({
    id,
  });
  const url = `${__BASE_API_URL__}/notification?${queryParams}`;

  return await privateFetch(
    url,
    {
      method: "DELETE",
    },
    false,
    false
  );
};

// accepts the above parameters in an object
export const sendNotification = async (params) => {
  const queryParams = queryString.stringify(params);
  // console.log(queryParams);
  const url = `${__BASE_API_URL__}/notification?${queryParams}`;

  return await privateFetch(
    url,
    {
      method: "POST",
    },
    false,
    false
  );
};
